/**
 * Type guard to check if a filter is a {@link FacetFilter}.
 *
 * @param filter - The filter to check.
 *
 * @returns  True if the filter is a {@link FacetFilter}, false otherwise.
 *
 * @public
 */
function isFacetFilter(filter) {
    return 'facetId' in filter;
}

export { isFacetFilter };
